import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";

export const ProfitFormDialog = ({
  isEditing,
  onChange,
  onOpenChange,
  onSubmit,
  open,
  profit,
  users,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="profit-dialog">
        <DialogHeader>
          <DialogTitle>{isEditing ? "Edit Profit" : "Add Profit"}</DialogTitle>
          <DialogDescription>
            Record a report profit for one selected user with its date, amount, and remark.
          </DialogDescription>
        </DialogHeader>
        <form className="dialog-form" onSubmit={onSubmit}>
          <Label htmlFor="profit-user">User</Label>
          <select
            id="profit-user"
            data-testid="profit-user-select"
            value={profit.agent_id}
            onChange={(event) => onChange("agent_id", event.target.value)}
            required
          >
            <option value="">Select user</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}{user.is_self ? " · Me" : ""}
              </option>
            ))}
          </select>
          <Label htmlFor="profit-description">Description</Label>
          <Input
            id="profit-description"
            data-testid="profit-description-input"
            value={profit.description}
            onChange={(event) => onChange("description", event.target.value)}
            required
          />
          <Label htmlFor="profit-amount">Amount</Label>
          <Input
            id="profit-amount"
            data-testid="profit-amount-input"
            type="number"
            min="1"
            step="0.01"
            value={profit.amount}
            onChange={(event) => onChange("amount", event.target.value)}
            required
          />
          <Label htmlFor="profit-date">Date</Label>
          <Input
            id="profit-date"
            data-testid="profit-date-input"
            type="date"
            value={profit.profit_date}
            onChange={(event) => onChange("profit_date", event.target.value)}
            required
          />
          <Label htmlFor="profit-notes">Remark</Label>
          <Textarea
            id="profit-notes"
            data-testid="profit-notes-input"
            value={profit.notes}
            onChange={(event) => onChange("notes", event.target.value)}
          />
          <Button type="submit" data-testid="save-profit-button">
            {isEditing ? "Save Profit Changes" : "Save Profit"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};